import type { CommandBody } from "../CrossOriginMessage";

export class ChangeStatusCommandBody implements CommandBody {
  status: string;
}
